<template>
  <v-form ref="form" @submit.prevent="submit" v-model="formValid">
    <v-row>
      <v-col cols="12" class="mt-8">
        <p class="mb-0 recover__subtitle">
          Insira sua nova senha:
        </p>
      </v-col>
      <v-col cols="12" class="mt-5">
        <BaseFormInput
          class="recover__form-input"
          id-element="passwordNew"
          placeholder="Senha"
          v-model="newPassword"
          type="password"
          required
          :rules="[requiredInput, minLength, passwordRules]"
          label-text="Nova senha"
          :upper-case="false"
          v-on:keyup.enter="submit()"
        />
      </v-col>
      <v-col cols="12">
        <BaseFormInput
          class="recover__form-input"
          id-element="passwordConfirmation"
          placeholder="Senha"
          v-model="newPasswordConfirmation"
          type="password"
          required
          :rules="[requiredInput, matchPasswords]"
          label-text="Confirme a nova senha"
          :upper-case="false"
          v-on:keyup.enter="submit()"
        />
      </v-col>
      <v-col cols="12" class="my-8">
        <BaseButton
          v-html="'CONCLUIR'"
          class="secondary font-weight-bold white--text"
          width="100%"
          type="submit"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { requiredInput, passwordRules } from "@/utils/rules.js";
import { mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  props: {
    token: { type: String }
  },
  data: () => ({
    formValid: true,
    requiredInput,
    newPassword: "",
    newPasswordConfirmation: "",
    passwordRules
  }),
  mixins: [LoadingRequest],
  methods: {
    ...mapActions("auth", ["requestRecoverPassword"]),
    submit() {
      if (this.$refs.form.validate()) {
        this.withLoading(
          this.requestRecoverPassword({
            nova_senha: this.newPassword,
            token_senha: this.token
          })
        )
          .then(() => {
            this.showAlertNotification({
              message: "Senha redefinida com sucesso",
              type: "success"
            });
            this.$emit("success");
          })
          .catch(error => {
            this.showAlertNotification({
              message: !error.response
                ? "Aconteceu um erro"
                : error.response.data.details &&
                  error.response.data.details.length > 0
                ? error.response.data.details.reduce(
                    (acc, { message }) => acc.concat(message),
                    ""
                  )
                : error.response.data.error_description,
              type: "error"
            });
          });
      }
    },
    matchPasswords(value) {
      return this.newPassword === value || "As senhas não coincidem";
    },
    minLength(value) {
      return value.length >= 8 || "Mínimo de 8 caracteres";
    }
  }
};
</script>
<style lang="sass">
.recover
  &__subtitle
    font-size: 18px
    font-weight: 600
    color: black !important
  &__form-input
    color: black !important
    label.form__label.primary--text
      color: white !important
</style>
